/**
 * A page's own tabs and the leave guard (5a smoke, Pedro 2026-11-01: "the guard fires if I try to
 * leave Portfolios, but not if I navigate within the Portfolios' tabs and leave the Assign trade
 * rules tab. It should").
 *
 * The router guard (DirtyFormProvider) sees leaving the PAGE, not switching between tabs inside it.
 * A page whose tabs hold Edit forms provides `TabDirtyCtx`; each such tab reports its dirty state
 * with `useReportTabDirty(dirty)`; the page asks (`confirmDiscardAsync`) before leaving a dirty tab
 * and renders that tab only while it is shown, so Discard really discards (§3g corollary 5).
 */
import { createContext, useContext, useEffect, useId } from 'react';

export const TabDirtyCtx = createContext<((id: string, dirty: boolean) => void) | null>(null);

export function useReportTabDirty(dirty: boolean) {
  const report = useContext(TabDirtyCtx);
  const id = useId();
  useEffect(() => {
    report?.(id, dirty);
    return () => report?.(id, false);
  }, [report, id, dirty]);
}
